/*
 * <sticky-atc> — barra fija de compra en la página de producto.
 * No agrega al carrito por su cuenta: refleja y dispara el botón real de la página,
 * así que hereda tallas agotadas, validaciones y el carrito del theme.
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('product-info .product-form__submit');
        this.button = this.querySelector('[data-sticky-atc-submit]');

        if (!this.mainButton || !this.button) {
          this.remove();
          return;
        }

        this.priceTarget = this.querySelector('[data-sticky-atc-price]');
        this.variantTarget = this.querySelector('[data-sticky-atc-variant]');
        this.showAfter = parseInt(this.dataset.showAfter, 10) || 300;
        this.defaultLabel = this.button.textContent.trim();
        this.variants = this.parseVariants();

        this.removeAttribute('hidden');

        this.button.addEventListener('click', () => this.mainButton.click());

        this.watchVisibility();
        this.watchVariant();
        this.watchButtonState();
        this.syncButtonState();
      }

      parseVariants() {
        const script = this.querySelector('[data-sticky-atc-variants]');
        if (!script) return [];
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return [];
        }
      }

      /* La barra sale solo cuando el botón real ya quedó arriba, fuera de la pantalla. */
      watchVisibility() {
        const update = () => {
          const rect = this.mainButton.getBoundingClientRect();
          const scrolledPast = rect.bottom < 0;
          const farEnough = window.scrollY > this.showAfter;
          this.classList.toggle('is-visible', scrolledPast && farEnough);
        };

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            update();
            this.ticking = false;
          });
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        update();
      }

      /* Sigue la talla elegida arriba. */
      watchVariant() {
        const input = document.querySelector('product-info form[data-type="add-to-cart-form"] input[name="id"]');
        if (!input) return;

        input.addEventListener('change', () => {
          const variant = this.variants.find((item) => String(item.id) === String(input.value));
          if (!variant) return;

          if (this.priceTarget) this.priceTarget.textContent = variant.price;
          if (this.variantTarget) this.variantTarget.textContent = ` · ${variant.title}`;
        });
      }

      /* Copia el estado del botón real: agotado, cargando, deshabilitado. */
      watchButtonState() {
        this.observer = new MutationObserver(() => this.syncButtonState());
        this.observer.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });
      }

      syncButtonState() {
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);

        if (disabled) {
          const label = this.mainButton.querySelector('span');
          this.button.textContent = label ? label.textContent.trim() : this.defaultLabel;
        } else {
          this.button.textContent = this.defaultLabel;
        }
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
